function DashboardConnectionsCtrl($auth, $state, ConnectionService, UserService, AppSettings, toaster) {
  'ngInject';

  const vm = this;
  vm.rows = [];
  vm.loading = true;

  function placeholder(provider, kind) {
    return {
      key: kind + '-empty',
      provider: provider,
      name: 'Not connected yet',
      status: 'Needs attention',
      connected: false,
      action: 'Connect',
      kind: kind
    };
  }

  function rowFromStatus(provider, name, kind, status, extra) {
    var connected = status === 'active';
    var row = {
      key: kind + '-' + ((extra && extra.id) || name),
      provider: provider,
      name: name,
      status: connected ? 'Connected' : 'Needs attention',
      connected: connected,
      action: connected ? null : (status ? 'Reconnect' : 'Connect'),
      kind: kind
    };
    if (extra) {
      Object.keys(extra).forEach(function (key) {
        row[key] = extra[key];
      });
    }
    return row;
  }

  function finish(pending, buckets) {
    pending.count -= 1;
    if (pending.count > 0) return;
    vm.rows = []
      .concat(buckets.xero.length ? buckets.xero : [placeholder('Xero', 'xero')])
      .concat(buckets.qbo.length ? buckets.qbo : [placeholder('QuickBooks', 'qbo')])
      .concat(buckets.amazon.length ? buckets.amazon : [placeholder('Amazon', 'amazon')]);
    vm.loading = false;
  }

  vm.load = function () {
    var pending = { count: 3 };
    var buckets = { xero: [], qbo: [], amazon: [] };

    UserService.listOrganizations('/organizations.json?page=1&size=20', function (response) {
      var orgs = (response && response.data && response.data.organizations) || [];
      if (!orgs.length) {
        finish(pending, buckets);
        return;
      }
      var left = orgs.length;
      orgs.forEach(function (entry) {
        var org = entry.organization || {};
        var connection = org.api_v1_xero_connection;
        if (!connection || !connection.id) {
          left -= 1;
          if (left === 0) finish(pending, buckets);
          return;
        }
        ConnectionService.getXeroStatus(connection.id, function (resp) {
          buckets.xero.push(rowFromStatus('Xero', org.name || 'Xero', 'xero', resp && resp.data && resp.data.status, { id: connection.id }));
          left -= 1;
          if (left === 0) finish(pending, buckets);
        });
      });
    });

    ConnectionService.getQboConnections('/qbo.json?page=1&size=20', function (response) {
      var list = (response && response.data && response.data.qbo_connections) || [];
      list.forEach(function (conn) {
        var name = conn.company_name || (conn.organization && conn.organization.name) || 'QuickBooks';
        buckets.qbo.push(rowFromStatus('QuickBooks', name, 'qbo', conn.status, { id: conn.id }));
      });
      finish(pending, buckets);
    });

    ConnectionService.connectAmazon('/amazon_connections.json?page=1&size=20', function (response) {
      var list = (response && response.data && response.data.amazon_connections) || [];
      list.forEach(function (con) {
        var connected = !!con.spapi_oauth_code;
        buckets.amazon.push({
          key: 'amazon-' + con.id,
          provider: 'Amazon',
          name: (con.api_v1_organization && con.api_v1_organization.name) || 'Amazon',
          status: connected ? 'Connected' : 'Needs attention',
          connected: connected,
          action: connected ? null : 'Reconnect',
          kind: 'amazon',
          id: con.id
        });
      });
      finish(pending, buckets);
    });
  };

  function postConnect(path) {
    var authHeaders = $auth.retrieveData('auth_headers') || {};
    if (!authHeaders['access-token'] || !authHeaders.client || !authHeaders.uid) {
      toaster.pop('error', 'Your session expired. Sign in again, then retry the connection.');
      return;
    }

    var form = document.createElement('form');
    form.method = 'POST';
    form.action = AppSettings.apiUrl + path;
    form.style.display = 'none';
    var fields = {
      'access-token': authHeaders['access-token'],
      client: authHeaders.client,
      expiry: authHeaders.expiry,
      uid: authHeaders.uid
    };
    Object.keys(fields).forEach(function (key) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = fields[key] == null ? '' : fields[key];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }

  vm.go = function (row) {
    if (row.kind === 'xero') {
      postConnect('/xero/connect');
      return;
    }
    if (row.kind === 'qbo') {
      postConnect('/qbo/connect');
      return;
    }
    if (row.kind === 'amazon' && row.action === 'Reconnect' && row.id) {
      var versionValue = process.env.NODE_ENV !== 'production' ? '&version=beta' : '';
      var amazonUrl = 'https://sellercentral.amazon.com/apps/authorize/consent?application_id=' + AppSettings.amazonApplicationId + '&redirect_uri=' + AppSettings.redirectUri + '&state=' + row.id.toString() + versionValue;
      window.open(amazonUrl);
      return;
    }
    $state.go('client.connectionView.amazon-conn');
  };
}

export default {
  name: 'DashboardConnectionsCtrl',
  fn: DashboardConnectionsCtrl
};
